import * as Yup from 'yup';

export const payrollValidationSchema = Yup.object().shape({
  employee: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Please select an employee')
    .required('Employee is required'),
  month: Yup.string().required('Month is required'),
  year: Yup.number()
    .typeError('Year must be a valid number')
    .required('Year is required')
    .min(2000, 'Year must be at least 2000')
    .max(2100, 'Year must not exceed 2100'),
  basic_salary: Yup.number()
    .typeError('Basic salary must be a valid number')
    .required('Basic salary is required')
    .min(0, 'Basic salary must be positive'),
  worked_days: Yup.number()
    .typeError('Worked days must be a valid number')
    .required('Worked days is required')
    .min(0, 'Worked days must be at least 0')
    .max(31, 'Worked days cannot exceed 31'),
  transport_allowance: Yup.number()
    .typeError('Transport allowance must be a valid number')
    .min(0, 'Transport allowance must be positive'),
  bonus_dues: Yup.number().typeError('Bonus dues must be a valid number').min(0, 'Bonus dues must be positive'),
  weekends_pay: Yup.number().typeError('Weekends pay must be a valid number').min(0, 'Weekends pay must be positive'),
  absent_deductions: Yup.number()
    .typeError('Absent deductions must be a valid number')
    .min(0, 'Absent deductions must be positive'),
  loan_deductions: Yup.number()
    .typeError('Loan deductions must be a valid number')
    .min(0, 'Loan deductions must be positive'),
  tax_deductions: Yup.number()
    .typeError('Tax deductions must be a valid number')
    .min(0, 'Tax deductions must be positive'),
  other_deductions: Yup.number()
    .typeError('Other deductions must be a valid number')
    .min(0, 'Other deductions must be positive'),
  late_deductions: Yup.number()
    .typeError('Late deductions must be a valid number')
    .min(0, 'Late deductions must be positive'),
  absent_days: Yup.number()
    .typeError('Absent days must be a valid number')
    .min(0, 'Absent days must be at least 0')
    .max(31, 'Absent days cannot exceed 31'),
  leave_days: Yup.number()
    .typeError('Leave days must be a valid number')
    .min(0, 'Leave days must be at least 0')
    .max(31, 'Leave days cannot exceed 31'),
  payment_status: Yup.string(),
  payment_mode: Yup.string(),
  payment_currency: Yup.string(),
  payment_date: Yup.string(),
});
